import { useLazyQueryAnalyticsFiles } from '@ion/api';
import useServerPagination from 'app/shared/hooks/data-table/useServerPagination';

const ANALYTICS_FILES_PER_PAGE = 10;
const DEFAULT_SORT = {
  field: 'pipeline',
  direction: 'asc',
};

export default function useAnalyticsFilesTableContextValue() {
  const [fetchAnalyticsFiles, { analyticsFiles, pagination, loading, refetch }] = useLazyQueryAnalyticsFiles();

  const { resetPagination, setActivePage, onSort } = useServerPagination({
    perPage: ANALYTICS_FILES_PER_PAGE,
    defaultSort: DEFAULT_SORT,
    fetchData: fetchAnalyticsFiles,
  });

  return {
    analyticsFiles: analyticsFiles ?? [],
    pagination,
    perPage: ANALYTICS_FILES_PER_PAGE,
    loading,
    resetPagination,
    setActivePage,
    onSort,
    refetch,
  };
}
